import { render, staticRenderFns } from "./PriceSectionMobile.vue?vue&type=template&id=705eda53&scoped=true&"
import script from "./PriceSectionMobile.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PriceSectionMobile.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PriceSectionMobile.vue?vue&type=style&index=0&id=705eda53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705eda53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('705eda53')) {
      api.createRecord('705eda53', component.options)
    } else {
      api.reload('705eda53', component.options)
    }
    module.hot.accept("./PriceSectionMobile.vue?vue&type=template&id=705eda53&scoped=true&", function () {
      api.rerender('705eda53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/PriceSectionMobile.vue"
export default component.exports